import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import LoginForm from './components/pages/LoginForm';
import CriarConta from './components/pages/CriarConta';
import Recover from './components/Recover';
import Menu from './components/Menu'; // Menu gerencia as páginas internas
import ProtectedRoute from './components/ProtectedRoute';

const App = () => {
  const location = useLocation();

  // Define se o menu deve ser exibido com base na rota atual
  const isAuthPage = ['/', '/register', '/forgot-password'].includes(location.pathname);

  return (
    <>
      {/* Exibe o menu somente se NÃO estiver em uma página de autenticação */}
      {!isAuthPage && 
       
           <ProtectedRoute>
            <Menu />
       </ProtectedRoute>
      }

      {/* Define as rotas principais */}
      <Routes>
        {/* Rotas de autenticação */}
  
        <Route path="/" element={<LoginForm />} />
        <Route path="/register" element={<CriarConta />} />
        <Route path="/forgot-password" element={<Recover />} />
     
        
      </Routes>
    </>
  );
};

export default App;
